import { render, staticRenderFns } from "./SpecialAdd.vue?vue&type=template&id=4a2de1b7&scoped=true"
import script from "./SpecialAdd.vue?vue&type=script&lang=js"
export * from "./SpecialAdd.vue?vue&type=script&lang=js"
import style0 from "./SpecialAdd.vue?vue&type=style&index=0&id=4a2de1b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2de1b7",
  null
  
)

export default component.exports